// extracted by mini-css-extract-plugin
export var searchItem = "search-result-module--searchItem--f9cb6";
export var searchMeta = "search-result-module--searchMeta--83895";